export default __webpack_public_path__ + "static/media/icons-arrow-up.111758e0.svg";